import React from 'react';

import NoticeHeader from 'components/checkout/modal-notices/notice-headers/notice-header';

const PrintOnlyHeader = () => (
  <NoticeHeader headerImgSrc="/images/checkout/zag-print.png">Gotta print your pass</NoticeHeader>
);

export default PrintOnlyHeader;
